/** @format */
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import * as formik from "formik";
import * as yup from "yup";
import PhoneInput from "react-phone-input-2";
import {
  useCreateCompany,
  useUpdateCompanyMe,
} from "../../../../../api/mutations/company.mutation";
import { useGetCompanyMe } from "../../../../../api/queries/company.query";

function CreateEmpProfileForm() {
  const { Formik } = formik;

  const schema = yup.object().shape({
    company_name: yup.string().required("Please enter your company name"),
    description: yup
      .string()
      .required("Please enter description for your company"),
    industry: yup.string().required("Please enter your cmpany industry"),
    address: yup.string().required("Please enter your address"),
    website: yup.string().required("Please enter your company website"),
    city: yup.string().required("Please enter your company location"),
    size: yup.string().required("Please enter your company size"),
    number: yup.string().required("Please enter your phone number"),
  });

  const empLoginMutation = useCreateCompany({
    onSuccess: (data) => {},
    onError: (error) => {
      if (error.message) {
        //Handle error msg
      }
    },
    successMessage: "Updated Successfully",
  });

  const onUpdate = (data) => {
    console.log(data);
    empLoginMutation.mutate({
      company_name: data.company_name,
      description: data.description,
      idustry: data.industry,
      address: data.address,
      website: data.website,
      city: data.city,
      size: data.size,
      contact: data.number,
    });
  };

  const initialValues = {
    company_name: "",
    description: "",
    industry: "",
    address: "",
    website: "",
    city: "",
    size: "",
    number: "",
  };

  return (
    <Formik
      validationSchema={schema}
      onSubmit={onUpdate}
      initialValues={initialValues}
      enableReinitialize
    >
      {({ handleSubmit, handleChange, values, touched, errors }) => (
        <Form noValidate onSubmit={handleSubmit} className="mt-5">
          <Row className="mb-2">
            <h3 className="mb-3">Create Employer Profile</h3>
            <p>Begin your hiring journey by creating your profile here.</p>
            <Form.Group
              as={Col}
              controlId="validationFormikCompanyName"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Your Company Name
              </Form.Label>
              <Form.Control
                type="company_name"
                placeholder="Company Name"
                name="company_name"
                value={values.company_name}
                onChange={handleChange}
                isInvalid={!!errors.company_name}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.company_name}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikDescription"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Description
              </Form.Label>
              <Form.Control
                type="description"
                placeholder="About the company"
                name="description"
                value={values.description}
                onChange={handleChange}
                isInvalid={!!errors.description}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.description}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikIndustry"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Industry Field
              </Form.Label>
              <Form.Control
                type="industry"
                placeholder="Technology"
                name="industry"
                value={values.industry}
                onChange={handleChange}
                isInvalid={!!errors.industry}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.industry}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikSize"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Company Size
              </Form.Label>
              <Form.Control
                type="size"
                placeholder="50-100"
                name="size"
                value={values.size}
                onChange={handleChange}
                isInvalid={!!errors.size}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.size}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikAddress"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Company Address
              </Form.Label>
              <Form.Control
                as="textarea"
                type="address"
                placeholder="Company Address"
                name="comp_address"
                value={values.address}
                onChange={handleChange}
                isInvalid={!!errors.address}
                className="form-control mb-0"
                rows={4}
              />
              <Form.Control.Feedback type="invalid">
                {errors.address}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikWebsite"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">Website</Form.Label>
              <Form.Control
                type="website"
                placeholder="www.company.com"
                name="website"
                value={values.website}
                onChange={handleChange}
                isInvalid={!!errors.website}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.website}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikCity"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">City</Form.Label>
              <Form.Control
                type="city"
                placeholder="Kuala Lumpur, Malaysia"
                name="city"
                value={values.city}
                onChange={handleChange}
                isInvalid={!!errors.city}
                className="form-control mb-0"
              />
              <Form.Control.Feedback type="invalid">
                {errors.city}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Row className="mb-2">
            <Form.Group
              as={Col}
              controlId="validationFormikPhoneNum"
              className="form-group text-start"
            >
              <Form.Label className="form-label fw-bold">
                Phone Number
              </Form.Label>
              <PhoneInput
                country={"my"}
                name="number"
                value={values.number}
                onChange={handleChange}
                inputStyle={{
                  height: "30px",
                  fontSize: "14px",
                }}
              />
              <Form.Control.Feedback type="invalid">
                {errors.number}
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <div className="text-end">
            <Button
              variant="success"
              type="submit"
              className="btn btn-success mt-4 fw-semibold text-uppercase"
            >
              Save & Update
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default CreateEmpProfileForm;
